import React, { useEffect, useState, useContext } from "react";
import { Card } from "@mui/material";
import { CardHeader } from "@mui/material";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import AsyncSelect from "react-select/async";
import AccountingApi from "../../../Classes/API/AccountingApi";
import searchUsersReq from "../../../Classes/Models/Requests/Users/SearchUser";
import UsersApi from "../../../Classes/API/UsersApi";
import UserTypes from "../../../Classes/Models/Requests/Users/UserTypes";
import Swal from "sweetalert2";
import CreateContractReq from "../../../Classes/Models/Requests/Accounting/CreateContractReq";
import { LanguageContext } from "App";
const ContractsSearch = ({ setSearchReq }) => {
  let req = new CreateContractReq();

  const [ContractId, setContractId] = useState();
  const [Name, setName] = useState("");
  const [Description, setDescription] = useState();
  const { translations } = useContext(LanguageContext);

  const onSearchClick = async () => {
    req.Id = ContractId;
    req.Name = Name;
    req.Description = Description;

    setSearchReq(req);
  };

  return (
    <Card sx={{ padding: "1em" }}>
      <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
        <MDTypography variant="h6" fontWeight="medium">
          {translations.contactssearch}
        </MDTypography>
        <div>
          <MDButton
            type="button"
            sx={{ backgroundColor: "#3560AD", "&:hover": { backgroundColor: "#4682B4" } }}
            color="text"
            onClick={() => onSearchClick()}
          >
            {translations.usrBalanceEnteriesSearch}
          </MDButton>
        </div>
      </MDBox>

      <div className={translations.setlang === "ar" ? "rtl-label" : ""}>
        <div className="container-fluid mt-3">
          <div className="row">
            <div className="col-md-4">
              <MDInput
                label={translations.contactssearchContractId}
                onChange={(e) => setContractId(e.target.value)}
                type="number"
                style={{ width: "100%" }}
                fullWidth
              />
            </div>

            <div className="col-md-4">
              <MDInput
                label={translations.contactssearchContractName}
                value={Name}
                onChange={(e) => setName(e.target.value)}
                style={{ width: "100%" }}
                fullWidth
              />
            </div>

            <div className="col-md-4">
              <MDInput
                label={translations.contactssearchDescription}
                value={Description}
                onChange={(e) => setDescription(e.target.value)}
                style={{ width: "100%" }}
                fullWidth
              />
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default ContractsSearch;
